import React from 'react'
import { pmDraftStatus, influencerDraftStatus, clientDraftStatus } from '../../utils/draftStatus'

const STATUS_BY_ROLE = { pm: pmDraftStatus, influencer: influencerDraftStatus, client: clientDraftStatus }

// label/color let a caller override the status-map lookup for cases the map
// can't express on its own (e.g. client_review looks the same whether or
// not this viewer has already acted on it this round).
export default function DraftStatusBadge({ draftStatus, role = 'pm', className = '', label: labelOverride, color: colorOverride }) {
  const { label, color } = labelOverride ? { label: labelOverride, color: colorOverride } : STATUS_BY_ROLE[role](draftStatus)

  return (
    <span className={`flex items-center gap-1.5 text-sm font-medium text-rb-black dark:text-white ${className}`}>
      <span className={`w-2 h-2 rounded-full ${color}`} />
      {label}
    </span>
  )
}
